"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteProfileBackground = void 0;
const endpointIds_1 = require("root/src/shared/descriptions/endpoints/endpointIds");
const auth_1 = require("root/src/shared/constants/auth");
const middlewareIds_1 = require("root/src/shared/descriptions/middlewares/middlewareIds");
const lenses_1 = require("root/src/shared/descriptions/endpoints/lenses");
const recordTypes_1 = require("root/src/shared/descriptions/endpoints/recordTypes");
exports.deleteProfileBackground = {
    [endpointIds_1.DELETE_PROFILE_BACKGROUND]: {
        authentication: auth_1.authenticationTypes.authenticated,
        middlewares: [middlewareIds_1.VALIDATE_TOKEN_ACCOUNT],
        endpointType: lenses_1.recordEndpointType,
        recordType: recordTypes_1.profile,
    },
};
